export class UserHome {
    documentCards!: Card[];
    trainingCards!: Card[];
}

class Card {
    name!: string;
    count!: number;
  }
